/** @format */
/// <reference="knockout">
(function (factory) {
  // Module systems magic dance.
  if (
    typeof require === "function" &&
    typeof exports === "object" &&
    typeof module === "object"
  ) {
    // CommonJS or Node: hard-coded dependency on "knockout"
    factory(require("knockout"));
  } else if (typeof define === "function" && define["amd"]) {
    // AMD anonymous module with hard-coded dependency on "knockout"
    define(["knockout"], factory);
  } else {
    // <script> tag: use the global `ko` object, attaching a `validation` property
    factory(ko);
  }
})(function (ko) {
  // this is the factory

  if (typeof ko === "undefined") {
    throw new Error(
      "Knockout is required; please ensure it is loaded before loading this plug-in"
    );
  }

  ko.deferredComputed = function (evaluatorOrOptions, target, options) {
    options = options || {};

    if (typeof evaluatorOrOptions == "object") {
      evaluatorOrOptions.deferEvaluation = true;
    } else {
      options.deferEvaluation = true;
    }

    return ko.computed(evaluatorOrOptions, target, options);
  };
});
